import { makeStyles } from "@material-ui/core/styles";
import { BorderRight } from "@material-ui/icons";
const useStyles = makeStyles(theme => ({
  divAlignCenter: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  disabledBtn:{
    borderColor:"#dbdbdc !important"
  },
  pageContentDIv: {
    //marginTop:30,
    padding: 24,
    height: 'calc(100vh - 115px)',
    overflow: 'auto'
  },
  bankIcon: {
    width: 30,
    height: 30
  },
  bankName: {
    fontSize: 14,
    color: '#0b1323',
    marginRight: 44,
  },
  pageContentDIvTrip: {
    padding: 24,
    paddingTop: 0,
    height: 'calc(100vh - 115px)',
    overflow: 'auto'
  },
  vehileNumber: {
    fontSize: 14,
    "&:last-child": {
      color: '#0033cc',
      marginLeft: 6
    },
    "&:nth-last-child(2)": {
      marginLeft: 6
    }
  },
  fastagTable: {

  },
  fastagVehiclesTable: {

  },
  statusName: {
    textTransform: 'capitalize',
    fontSize: 10,
    textAlign: 'center'
  },
  active: {
    padding: "2px 22px",
    textAlign: 'center',
    borderRadius: 5,
    backgroundColor: '#b8eed1',
    fontSize:10
  },
  blacklisted: {
    padding: "2px 22px",
    textAlign: 'center',
    borderRadius: 5,
    backgroundColor: '#ffaaaa',
    fontSize:10
  },
  inactive: {
    padding: "2px 22px",
    textAlign: 'center',
    borderRadius: 5,
    backgroundColor: '#e6e6e6',
    fontSize:10
  },
  unregistered: {
    padding: "2px 22px",
    textAlign: 'center',
    color: "#fff !important",
    borderRadius: 5,
    backgroundColor: '#0b1323',
    fontSize:10
  },
  actionButton:{
    textTransform:'capitalize',
    fontWeight:300,
    color:'#0033cc',
    borderColor:'#0033cc',
    fontSize:12,
    fontWeight:600
  },
  drflex: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  drflexDetails: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    backgroundColor: '#f9f9fa',
    borderRadius: 8,
    width: 'fit-content'
  },
  amount: {
    fontSize: 14,
    fontWeight: 600,
    color: '#0b1323'
  },
  dotOp: {
    fontSize: 8,
    color: 'rgba(168, 176, 189, 0.5)',
    margin: '0px 8px'
  },
  balanceRefreshDiv: {
    padding: "0px 24px",
    borderRight: "1px solid rgba(0, 0, 0, 0.1)"
  },
  balanceDiv: {
    marginBottom: 12
  },
  fastagBalance: {
    color: '#1424b4',
    fontSize: 19
  },
  lastChecked: {
    color: '#6d7278',
    fontSize: 14
  },
  balanceFetchedAt: {
    color: '#0b1323',
    fontSize: 14
  },
  vehicleDetailsDiv: {
    padding: "0px 48px",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  refreshBalanceButton: {
    boxShadow: 'none',
    color: '#4d4ab5',
    textTransform: 'capitalize',
    backgroundColor: '#FFF',
    fontWeight: 'bold',
    paddingBottom: 8,
    paddingTop: 8,
    borderRadius: 4,
    maxHeight:36,
    padding:"8px 38px",
    border: '1px solid #4d4ab5',
    "&:hover": {
      backgroundColor: '#4d4ab5',
      color: "#fff",
      border: '1px solid #4d4ab5',
    }
  },
  balanceAttemptsMessage: {
    fontSize: 12,
    color: '#0a142a',
    marginLeft: 16,
    fontWeight: 600
  },
  subTitle: {
    color: '#6d7278',
    fontSize: 12,
    marginBottom: 4
  },
  vehicleNumberDiv: {
    marginRight: 48
  },
  bankIconDiv: {
    marginLeft: 16
  },
  bankIcon: {
    width: 30,
    height: 30
  },
  tableTitleIcon: {
    fontSize: 24
  },
  tableTitle: {
    display: "flex",
    alignItems: 'center',
    marginBottom: 30
  },
  title: {
    paddingLeft: 24,
    fontSize: 18,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#0b1323'
  },
  dividerDiv: {
    borderBottom: '1px dotted rgba(11, 19, 35, 0.25)',
    margin: "24px 0px"
  },
  fastTagRechargeTable: {
    '& .MuiToolbar-root': {
      //display:'none !important',
      paddingTop: 0,
      paddingBottom: 0,
      minHeight: 0
    }
  },
  emptyStateDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 30
  },
  emptyTxt: {
    marginTop: 32,
    fontSize: 20,
    color: 'rgba(11, 19, 35, 0.75)'
  },
  highlight: {
    color: "#1860f0",
    padding: 0
  },
  amountDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  statusDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  amountTxt: {
    marginRight: 16
  },
  rechargeAgain: {
    padding: "4px 12px",
    borderRadius: 4,
    border: "solid 1px #0033cc",
    backgroundColor: "inherit",
    color: "#0033cc",
    fontWeight: 300,
    textTransform: "capitalize"
  },
  nameDivIcon: {
    display: 'flex',
    alignItems: 'center',
    width: 30,
    "& .MuiSvgIcon-root": {
      //width:32,
      //height:32
    }
  },
  iconDiv: {
    //marginRight: 60
    marginLeft:8
  },
  listEmptyStateDesc: {
    fontSize: 24,
    fontWeight: 600,
    color: 'rgba(11, 19, 35, 0.75)',
    marginTop: 48
  },
  listEmptyState: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '-webkit-fill-available'
  },
  trLastDate:{
    fontSize:12,
    color:'#6b778c'
  },
  arrowBalance:{
    marginLeft:'auto',
    fontSize:24,
    opacity:'0.5'
  },
  actionDash:{
    display:'flex',
    justifyContent:'center'
  }
}));
export default useStyles;